/**************************************************
 * Nombre:       Formulario_Pedido_Envio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {PictureAsPdf} from "@mui/icons-material";
import logoRedondo from "../../Recursos/logo_redondo.svg"
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {guardarFecha} from "../../Servicios/Local/guardarFecha";
import Formulario_Pedido_Envio from "../Formularios/Formulario_Pedido_Envio";
import {generarGuia} from "../../Modulo_envios/Funciones/generarGuia";
import {BODEGA} from "../../Modulo_envios/Constantes_Bodega";
import {obtenerValorTotal} from "../../Modulo_envios/Funciones/obtenerValorTotal";
import {useState} from "react";
import {irUrl} from "../../Utilidades/irUrl";

const Dialogo_Pedido_Envio = ({datos, cerrar, realizado}) => {
    const [url, setUrl] = useState('')
    const [cargando, setCargando] = useState(false)
    const {
        props,
        obtenerEntidad,
    } = useFormulario({
        valoresDefecto: datos
    })
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'dos'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga()

        let dox = await guardarDoc('pedidos', entidad)
        if (dox.res) {
            await guardarFecha()
            terminar({aviso: 'Datos de pedido actualizados'})
        } else {
            terminar({aviso: 'No se subieron los datos, intentelo nuevamente', variante: 'error'})
        }

    }

    const guardarDatosGuia = async (url) => {
        props.setValue('urlGuia', url)
        let entidad = await obtenerEntidad()
        entidad.urlGuia = url
        await guardarDoc('pedidos', entidad)
        setUrl(url)
        setCargando(false)
        irUrl(url)
    }

    const crearGuia = async () => {

        if (url) {
            irUrl(url)
            return
        }

        if (datos.idEnvio === 'gratis') {
            terminar({aviso: 'El envio es gratis, genera la guia en EnvioClick'})
            return
        }

        setCargando(true)
        let valorProductos = obtenerValorTotal(datos.productos)
        let guia = await generarGuia({bodega: BODEGA, pedido: datos, valorTotal: valorProductos})
        if (guia.res) {
            await guardarDatosGuia(guia.data.url)
        } else {
            let obj = {
                nombre: 'Error al crear guia',
                fecha: new Date().getTime(),
                datos: JSON.stringify(guia.dataError)
            }
            await guardarDoc('errores', obj)
            nuevoAviso({aviso: 'Error al crear guia, porfavor contacta al desarrollador', variante: 'error'})
            setCargando(false)
        }

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Pedido_Envio props={props}/>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', marginTop: 3}}>
                <Button
                    disabled={datos.urlGuia && !url}
                    loading={cargando}
                    variant={'outlined'}
                    startIcon={<PictureAsPdf/>}
                    onClick={() => crearGuia()}
                >Crear Guia</Button>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-end', marginTop: 3}}>
                <Button
                    disabled={!datos.urlGuia || url}
                    variant={'outlined'}
                    startIcon={<PictureAsPdf/>}
                    onClick={() => irUrl(datos.urlGuia)}
                >Ver Guia</Button>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Pedido_Envio